import * as React from 'react';
import { VendorSearchViewModel } from '@models/Vendor';
import { Link } from 'react-router-dom';
import { getRoute } from '@common/route-definitions';
import { RouteDefinitions } from '@common/route-definitions';
import ReactTable, { Column } from 'react-table';
import { LocalForm, Control, Errors, actions } from 'react-redux-form';
import { getDefaultErrorMessages } from '@common/validators';
import { TradeOptionsViewModel } from '@models/ServiceWorkOrder';
import { Select, DynamicSelectIdentifier } from '@common/components';
import { OptionsViewModel } from '@models/common.models';
import { TooltipComponent } from '@common/components/tooltip/tooltip.component';
import { Dispatch } from 'react-redux';

export interface VendorDashboardComponentProperties {
  readonly searchVendors: (
    query: string | null,
    pageSize: number,
    pageNumber: number,
    orderBy: string,
    orderDirection: string,
    trade?: TradeOptionsViewModel,
    type?: OptionsViewModel,
    status?: OptionsViewModel,
    group?: OptionsViewModel
  ) => void;
  readonly vendorSearchResults: VendorSearchViewModel[];

  readonly message: string;
  readonly searchQuery: string | null;
  readonly searchLoading: boolean;
  readonly searchPageNumber: number;
  readonly searchPageSize: number;
  readonly searchPageCount: number;
  readonly searchResultsTotalCount: number;

  readonly getTrades: () => Promise<void>;
  readonly type: OptionsViewModel;
  readonly status: OptionsViewModel;
  readonly trade: TradeOptionsViewModel;
  readonly trades?: TradeOptionsViewModel[];

  readonly filters: Array<OptionsViewModel>;
  readonly statusFilters: Array<OptionsViewModel>;
  readonly groupFilters: Array<OptionsViewModel>;
  readonly group: OptionsViewModel;
}

interface FormModel {
  readonly query: string;
  readonly trade: string;
  readonly type: string;
  readonly status: string;
  readonly group: string;
}

export class VendorDashboardComponent extends React.Component<VendorDashboardComponentProperties> {
  formDispatch: Dispatch<any>;
  isInitialized: boolean = false;
  componentDidMount() {
    if (!this.props.trades) {
      this.props.getTrades();
      this.handleSearch('', '', '', '', '');
    }
    if (this.props.type) {
      this.formDispatch(actions.change('vendorSearch.type', this.props.type.id));
    }
    if (this.props.trade) {
      this.formDispatch(actions.change('vendorSearch.trade', this.props.trade.id));
    }
    if (this.props.status) {
      this.formDispatch(actions.change('vendorSearch.status', this.props.status.id));
    }
    if (this.props.group) {
      this.formDispatch(actions.change('vendorSearch.group', this.props.group.id));
    }
  }
  attachDispatch = (dispatch: Dispatch<any>) => {
    this.formDispatch = dispatch;
  };

  render() {
    const columns: Column[] = [
      {
        accessor: (row: VendorSearchViewModel) => (
          <Link
            to={getRoute(RouteDefinitions.vendor.Details, {
              id: row.id
            })}
            target="_blank"
            title={`id: ${row.id}
            Rating: ${row.rating}            
            Suspended: ${row.isSuspended ? 'YES' : 'NO'}
            Liability: ${row.isLiabilityWaived ? 'WAVED' : 'LIABLE'}
            Dispatch Count: ${row.dispatchCount}
            Redispatch %: ${row.redispatchPercentage}
            VGroup: ${row.group}`}
          >
            {row.name}
          </Link>
        ),
        id: 'name',
        Header: 'Company Name',
        sortable: true,
        defaultSortDesc: true
      },
      {
        accessor: 'status',
        Header: 'Status',
        sortable: true,
        width: 100,
        defaultSortDesc: true
      },
      {
        accessor: 'address.line1',
        Header: 'Address',
        sortable: true,
        width: 175,
        defaultSortDesc: true
      },
      {
        accessor: 'address.city',
        Header: 'City',
        sortable: true,
        width: 125,
        defaultSortDesc: true
      },
      {
        accessor: 'address.state',
        Header: 'State',
        sortable: true,
        width: 55,
        defaultSortDesc: true
      },
      {
        accessor: 'address.zip',
        Header: 'Zip',
        sortable: false,
        width: 80
      },
      {
        accessor: 'email',
        Header: 'Email',
        width: 125,
        sortable: true,
        defaultSortDesc: true
      },
      {
        accessor: (row: VendorSearchViewModel) => (row && row.group ? row.group : 'N/A'),
        id: 'group',
        Header: 'Vendor Group',
        sortable: true,
        defaultSortDesc: true,
        width: 200
      }
    ];
    return (
      <div className="pb-10">
        <LocalForm
          className="form-horizontal"
          hideNativeErrors={true}
          onSubmit={(props: FormModel) =>
            this.handleSearch(props.query, props.trade, props.type, props.status, props.group)
          }
          model="vendorSearch"
          getDispatch={(dispatch: Dispatch<any>) => this.attachDispatch(dispatch)}
        >
          <div className="row">
            <div className="col-md-6">
              <h2>Vendors</h2>
            </div>
            <div className="col-md-6 text-right">
              <Link to={getRoute(RouteDefinitions.vendor.Create, {})}>
                <button className="btn btn-primary" type="button">
                  Begin Vendor Procurement
                </button>
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row text-left">
                <div className="col-md-2">
                  <label htmlFor=".status">Filter By Status:</label>
                  <Select
                    id="status"
                    identifier={DynamicSelectIdentifier.VendorStatuses}
                    model=".status"
                    validateOn="change"
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor=".type">Filter By Type:</label>
                  <Select
                    id="type"
                    identifier={DynamicSelectIdentifier.VendorTypes}
                    model=".type"
                    validateOn="change"
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor=".type">Filter By Group:</label>
                  <Select
                    id="type"
                    identifier={DynamicSelectIdentifier.VendorGroups}
                    model=".group"
                    validateOn="change"
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor=".trade">Filter by Trade:</label>
                  <Control.select id="trade" model=".trade">
                    {this.renderTradeOptions()}
                  </Control.select>
                </div>
                <div className="col-md-4">
                  <label htmlFor=".query">Search</label>
                  <TooltipComponent text="Search by ID#, Name, Phone, Zip Code, City, Address, or Email" side="top" />
                  <Control.text model=".query" />
                  <Errors
                    className="error"
                    model=".query"
                    show={{ touched: true, focus: false }}
                    messages={getDefaultErrorMessages()}
                  />
                  {this.props.searchResultsTotalCount > 10000 && (
                    <span> Your search is too broad. Narrow the search with more specific terms. </span>
                  )}
                </div>
              </div>
              <div className="row center-xs text-right">
                <button className="btn btn-primary" disabled={this.props.searchLoading} type="submit">
                  Search
                </button>
              </div>
            </div>
          </div>
        </LocalForm>

        <div>
          <ReactTable
            onPageChange={() => {
              Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
                element.scrollTop = 0;
              });
            }}
            className="-striped -highlight"
            columns={columns}
            data={this.props.vendorSearchResults.filter(v => v.id > 1)} // id == 1 is "Call Own Sub"
            defaultPageSize={10}
            loading={this.props.searchLoading}
            manual={true}
            onFetchData={this.handleFetchData}
            pages={this.props.searchPageCount}
            previousText="Prev"
          />
        </div>
      </div>
    );
  }

  private renderTradeOptions() {
    if (!this.props.trades) {
      return <></>;
    }

    let uniqueKeys: Array<number> = [];
    for (let t of this.props.trades) {
      if (uniqueKeys.indexOf(t.tradeAnalysisId) === -1 && t.tradeAnalysisName !== 'Total Trades') {
        uniqueKeys.push(t.tradeAnalysisId);
      }
    }

    const options: Array<JSX.Element> = uniqueKeys.map(t => {
      const trade: TradeOptionsViewModel | undefined = this.props.trades!.find(tr => tr.id === t);
      return <option key={trade!.id}>{trade!.value}</option>;
    });
    options.unshift(<option key={-1}>Select one...</option>);

    return <>{options}</>;
  }
  private handleFetchData = (state: {
    page: number;
    pageSize: number;
    sorted: Array<{ id: string; desc: boolean }>;
  }): void => {
    const orderBy = state.sorted[0] ? state.sorted[0].id : 'id';
    const orderDirection = state.sorted[0] ? (state.sorted[0].desc ? 'desc' : 'asc') : 'asc';
    const tradeOption: TradeOptionsViewModel | undefined = this.props.trades
      ? this.props.trades.find(f => f.id === (this.props.trade ? this.props.trade.id : -1))
      : undefined;
    const typeOption: OptionsViewModel | undefined = this.props.filters.find(
      f => f.id === (this.props.type ? this.props.type.id : -1)
    );
    const statusOption: OptionsViewModel | undefined = this.props.statusFilters.find(
      f => f.id === (this.props.status ? this.props.status.id : -1)
    );
    const groupOption: OptionsViewModel | undefined = this.props.groupFilters.find(
      f => f.id === (this.props.group ? this.props.group.id : -1)
    );

    if (this.isInitialized) {
      this.props.searchVendors(
        this.props.searchQuery,
        state.pageSize,
        state.page + 1,
        orderBy,
        orderDirection,
        tradeOption,
        typeOption,
        statusOption,
        groupOption
      );
    }
    this.isInitialized = true;
  };

  private handleSearch = (query: string, trade: string, type: string, status: string, group: string): void => {
    this.isInitialized = true;
    const tradeOption: TradeOptionsViewModel | undefined = this.props.trades
      ? this.props.trades.find(f => f.value === trade)
      : undefined;
    const typeOption: OptionsViewModel | undefined = this.props.filters.find(f => f.id === +type);
    const statusOption: OptionsViewModel | undefined = this.props.statusFilters.find(f => f.id === +status);
    const groupsOption: OptionsViewModel | undefined = this.props.groupFilters.find(f => f.id === +group);
    this.props.searchVendors(
      query,
      this.props.searchPageSize,
      1,
      'id',
      'asc',
      tradeOption,
      typeOption,
      statusOption,
      groupsOption
    );
  };
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-dashboard/_components/vendor-dashboard.component.tsx